<template>
  <div
    v-if="isRevValidatedStatus || isFinanciallyValidatedStatus"
    class="d-flex align-center"
  >
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-icon
          v-on="on"
          v-if="isFinanciallyValidatedStatus && isRevValidatedStatus"
          color="green"
          size="16"
          >mdi-check-decagram</v-icon
        >
        <v-icon v-on="on" v-else color="green" size="16"
          >mdi-rocket-launch</v-icon
        >
      </template>
      {{
        isFinanciallyValidatedStatus && isRevValidatedStatus
          ? $t('rev.status.impact_validated')
          : $t('rev.validation.implementation_validated')
      }}
    </v-tooltip>
  </div>
</template>
<script>
export default {
  name: 'ValidationIndicator',
  props: {
    isRevValidatedStatus: {
      type: Boolean,
      required: false,
      default: false,
    },
    isFinanciallyValidatedStatus: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>
